/** In-app confirm dialog (avoids window.confirm behind extension/taskpane chrome). */
function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className)
        node.className = className;
    if (text !== undefined)
        node.textContent = text;
    return node;
}
export function showConfirmDialog(root, options) {
    return new Promise((resolve) => {
        root.querySelector(".confirm-overlay")?.remove();
        const overlay = el("div", "confirm-overlay");
        const dialog = el("div", "confirm-dialog card");
        dialog.setAttribute("role", "alertdialog");
        dialog.setAttribute("aria-modal", "true");
        const title = el("h2", "confirm-title", options.title);
        const message = el("p", "confirm-message", options.message);
        const actions = el("div", "confirm-actions");
        const cancel = el("button", "btn btn-secondary", options.cancelLabel ?? "Cancel");
        cancel.type = "button";
        const confirm = el("button", `btn ${options.danger ? "btn-danger" : "btn-primary"}`, options.confirmLabel ?? "Confirm");
        confirm.type = "button";
        const close = (result) => {
            overlay.remove();
            resolve(result);
        };
        cancel.addEventListener("click", () => close(false));
        confirm.addEventListener("click", () => close(true));
        overlay.addEventListener("click", (event) => {
            if (event.target === overlay) {
                close(false);
            }
        });
        actions.append(cancel, confirm);
        dialog.append(title, message, actions);
        overlay.append(dialog);
        root.append(overlay);
        cancel.focus();
    });
}
